var _path, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 13.6108C16.667 13.9175 16.4295 14.1667 16.1362 14.1667H15.417V12.5C15.417 11.5808 14.6695 10.8333 13.7503 10.8333H6.25033C5.33116 10.8333 4.58366 11.5808 4.58366 12.5V14.1667H3.86449C3.57116 14.1667 3.33366 13.9175 3.33366 13.6108V8.05583C3.33366 7.74917 3.57116 7.5 3.86449 7.5H5.00033H6.66699H13.3337H15.0003H16.1362C16.4295 7.5 16.667 7.74917 16.667 8.05583V13.6108ZM6.25033 15.8333V12.5H13.7503L13.752 15.8333H6.25033ZM6.67866 4.16667H13.3337V5.83333H6.67283L6.67866 4.16667ZM16.1362 5.83333H15.0003V4.16667C15.0003 3.2475 14.3153 2.5 13.4728 2.5H6.52783C5.68533 2.5 5.00033 3.2475 5.00033 4.16667V5.83333H3.86449C2.65283 5.83333 1.66699 6.83 1.66699 8.05583V13.6108C1.66699 14.8367 2.65283 15.8333 3.86449 15.8333H4.58366C4.58366 16.7525 5.33116 17.5 6.25033 17.5H13.7503C14.6695 17.5 15.417 16.7525 15.417 15.8333H16.1362C17.3478 15.8333 18.3337 14.8367 18.3337 13.6108V8.05583C18.3337 6.83 17.3478 5.83333 16.1362 5.83333Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 18,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 13.6108C16.667 13.9175 16.4295 14.1667 16.1362 14.1667H15.417V12.5C15.417 11.5808 14.6695 10.8333 13.7503 10.8333H6.25033C5.33116 10.8333 4.58366 11.5808 4.58366 12.5V14.1667H3.86449C3.57116 14.1667 3.33366 13.9175 3.33366 13.6108V8.05583C3.33366 7.74917 3.57116 7.5 3.86449 7.5H5.00033H6.66699H13.3337H15.0003H16.1362C16.4295 7.5 16.667 7.74917 16.667 8.05583V13.6108ZM6.25033 15.8333V12.5H13.7503L13.752 15.8333H6.25033ZM6.67866 4.16667H13.3337V5.83333H6.67283L6.67866 4.16667ZM16.1362 5.83333H15.0003V4.16667C15.0003 3.2475 14.3153 2.5 13.4728 2.5H6.52783C5.68533 2.5 5.00033 3.2475 5.00033 4.16667V5.83333H3.86449C2.65283 5.83333 1.66699 6.83 1.66699 8.05583V13.6108C1.66699 14.8367 2.65283 15.8333 3.86449 15.8333H4.58366C4.58366 16.7525 5.33116 17.5 6.25033 17.5H13.7503C14.6695 17.5 15.417 16.7525 15.417 15.8333H16.1362C17.3478 15.8333 18.3337 14.8367 18.3337 13.6108V8.05583C18.3337 6.83 17.3478 5.83333 16.1362 5.83333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.251d359c.svg";
export { ForwardRef as ReactComponent };